import { useEffect, useState } from "react";
import { _TaxSchemeValue } from "../../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../../core/services/dataBean/useDataBean";
import { TaxableArticleTypesEditor } from "../../../../../../../admin/ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxableArticleTypes.editor";
import { TaxFilerTypesEditor } from "../../../../../../../admin/ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxFilerTypes.editor";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../../theme/Component/Modal";
import { SelectTaxSchemeContext } from "../../../../../../../admin/ConfImpuestos/TaxSchemeCode/SelectTaxSchemeContext";

interface Form {
    IDtaxFillerType: number;
    IDAdquistionArticleType: number;
    IDTaxSchemeContext: number;
    IDTaxScheme: number;
}

interface Props {
    configProps?: conf;
    _onChange: Function;
    _Value: any;
}

interface conf {
    label?: string;
    renderValue?: string;
}

export const EditorTaxSchemeValue = ({ _Value, _onChange, configProps }: Props) => {

    const { setBean, bean, lista, setLista, instance } = useDataBean(_TaxSchemeValue);
    const [response, setResponse] = useState<Partial<Form>>({});
    const [listaScheme, setListaScheme] = useState<any>([]);

    const [valor, setValor] = useState<string>("")
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const getLista = () => {
        instance.getTaxSchemeValueCatalogAvailable(response.IDTaxScheme, response.IDAdquistionArticleType, response.IDtaxFillerType).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { console.log(err) })
    }

    useEffect(() => {
        if (configProps?.renderValue) {
            setValor(configProps?.renderValue)
        }
    }, [configProps?.renderValue])

    useEffect(() => {
        getTaxSchemeCatalogWithHoldingTax();
    }, [response.IDAdquistionArticleType, response.IDTaxSchemeContext, response.IDtaxFillerType])

    const getTaxSchemeCatalogWithHoldingTax = () => {
        instance.getTaxSchemeCatalogWithHoldingTax(response.IDTaxSchemeContext, response.IDAdquistionArticleType, response.IDtaxFillerType).then(
            (resp) => {
                setListaScheme(resp)
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDTaxSchemeValue' },
        { title: 'Tipo de Impuestos', property: 'TaxSchemeName' },
        { title: 'Valor', property: 'TaxValueName' },
        { title: 'Tipo', property: 'ValueTypeName' },
        { title: 'Descripción', property: 'Description' },
    ]

    const returnItem = () => {
        if (bean.IDTaxSchemeValue) {
            if (_onChange) {
                _onChange(bean)
            }
            setValor(`${bean.TaxSchemeName} - ${bean.ValueTypeName} ${bean.TaxValueName}`);
            setModal({ ...modal, "view": false });
        } else {
            toast.error("Impuesto no Valido");
        }
    }

    return (
        <>
            <label>{configProps?.label ?? "Impuesto"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true, "name": "Obligaciones Presupuestales del tercero" })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={returnItem}>
                <div className="row">
                    <div className="col-6">
                        <TaxableArticleTypesEditor idSelector={response.IDAdquistionArticleType} onChange={(e) => { setResponse({ ...response, IDAdquistionArticleType: e }) }} />
                    </div>
                    <div className="col-6">
                        <TaxFilerTypesEditor idSelector={response.IDtaxFillerType} onChange={(e) => { setResponse({ ...response, IDtaxFillerType: e }) }} />
                    </div>
                    <div className="col-6">
                        <SelectTaxSchemeContext idSelector={response.IDTaxSchemeContext} onChange={(e) => { setResponse({ ...response, IDTaxSchemeContext: e }) }} />
                    </div>
                    <div className="col-6">
                        {listaScheme.length > 0 &&
                            <>
                                <label>Tipos de Impuesto</label>
                                <select className="form-select" value={response.IDTaxScheme} onChange={(e: any) => {
                                    if (e === "") {
                                        setResponse({ ...response, "IDTaxScheme": null })
                                    } else {
                                        setResponse({ ...response, "IDTaxScheme": parseInt(e.target.value) })
                                    }
                                }}>
                                    <option value={null}>...</option>
                                    {listaScheme &&
                                        listaScheme.map((item: any) => {
                                            return (
                                                <option value={item.DataBeanProperties.IDTaxScheme} >{item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </>
                        }
                    </div>

                    <div className="col-2">
                        <BasicButton icon="ri-search-line" eventClick={() => {
                            getLista()
                        }} >Buscar</BasicButton>
                    </div>

                    <BasicTable body={lista} head={head} rowSet={setBean} />
                </div>
            </Modal>
        </>
    )
}